<template>
    <div>
        <empty-view @action="$modal.show('add-recruitment-modal');" v-if="vacancies.length == 0" title="Geen vacatures" message="Er zijn geen openstaande vacatures beschikbaar. Vacatures worden op de pagina van de markt getoond en zijn deelbaar via social media." actionText="Stel een vacature op"></empty-view>

        <add-recruitment-modal></add-recruitment-modal>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import firebase from 'firebase';
    import RemoveTimeModal from './modals/RemoveTimeModal.vue';
    import AddTimeModal from './modals/AddTimeModal.vue';
    import AddRecruitmentModal from './modals/AddRecruitmentModal.vue';

    import {getDayLong, getDaysLong} from '@/utils';
    import EmptyView from '@/components/general/EmptyView';

    require("firebase/firestore");

    @Component
    export default class RecruitmentPage extends Vue {

        vacancies = [];

        loading = true;

        mounted() {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    this.fetchMarket();
                } else {
                    // No user is signed in.
                    console.log(App.name, 'User is signed out');
                    this.$router.push('/auth');
                }
            });
        }

        fetchMarket() {
            firebase.firestore().collection('markets').doc(this.$route.params.key)
              .get()
              .then((snap) => {
                  console.log('Stand!', snap.data());

                  this.loading = false;
                  this.market = snap.data();
              }).catch((error) => {
                console.error('Error', error);
                this.loading = false;
            });
        }
    }

    Vue.component('recruitment-page', RecruitmentPage);
</script>



// WEBPACK FOOTER //
// src/pages/market/RecruitmentPage.vue